/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */
// React
import React from "react";

// MUI
import { Box } from "@mui/material";

/* ---------------------------------------------------------------------
 *                            Home Component
 * --------------------------------------------------------------------- */

/**
 * 定义首页组件
 * @returns 首页组件
 * @function Home
 * @static
 */
export default function Home() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "24px",
        color: "#222",
      }}
    >
      欢迎使用四加，右上角添加店铺，四加可以更好的帮助你运营！
    </Box>
  );
}
